import React, {createContext} from 'react'

interface ModalContextInterface {
  modal: React.ReactNode | null
  setModal: (value: React.ReactNode | null) => void
  hideModal: () => void
  modalIsShow: boolean
}

const modalContext = createContext<ModalContextInterface>({
  modal: null,
  setModal: (value) => {},
  hideModal: () => {},
  modalIsShow: false,
})

export default modalContext
